import Vue from 'vue';
import {Emit, Prop, InjectReactive} from 'vue-property-decorator';
import locales from './locales/Button.json'
import LabelParameters from "./Button/ButtonLabel/ButtonLabelSimpleParameters";
import ButtonParameters from "./IButtonParameters";

/** Classe permettant d'avoir la liste des paramètres de base des boutons */
export default class Button extends Vue {
    /** Droit visé dans l'emploi du bouton */
    @Prop({default: () => ''})
    public Right!: string;

    /** Feature employée pour définir les droits obligatoires dans l'emploi du bouton */
    @Prop({default: () => ''})
    public FeatureName!: string;

    /** Action employée pour définir les droits obligatoires dans l'emploi du bouton */
    @InjectReactive()
    public Action!: string;

    @Prop({default: () => false})
    public Disabled!: boolean;

    @Prop({default: () => false})
    public Border!: boolean;

    @Prop({default: () => ''})
    public Tooltip!: string;

    /** Variant du composant */
    @Prop({default: () => null})
    private VariantOverride!: string | null;

    @InjectReactive('Variant')
    private readonly VariantInjecte!: string;

    get Variant(): string {
        // Si la prop de surcharge a été passée, on l'utilise.
        if (this.VariantOverride) {
            return this.VariantOverride;
        }

        // Sinon, on utilise la valeur injectée.
        return this.VariantInjecte;
    }
    
    set Variant(value: string){
        this.VariantOverride = value;
    }

    /** Permet la traduction des différents boutons */
    public static MessageLocales() {
        return {messages: locales};
    }

    /** à partir d'un fichier permet de lister les classes présentes et d'instancier la classe de bouton du type désiré */
    public static GetConstructorParametersButton(ParameterFile: { [key: string]: typeof ButtonParameters },
                                                 action: string, right: string): ButtonParameters {
        if (Object.keys(ParameterFile).includes(action)) {
            let buttonConstructor: typeof ButtonParameters = ParameterFile[action];

            type ParameterType = new (right: string, datas?: any) => ButtonParameters; // Définition du type du constructeur

            // Accède au constructeur de la classe en utilisant la chaîne de caractères
            let classeConstructeur: ParameterType = buttonConstructor as ParameterType;

            // Vérifie si c'est bien une fonction (une classe est une fonction Constructeur)
            if (typeof classeConstructeur === 'function') {
                // Instancie la classe
                let button: ButtonParameters = new classeConstructeur(right, {});
                if (button.Right == undefined || button.Right == '')
                    button.Right = 'Read';
                return button;
            }
        }
        console.debug('Button - GetConstructorParametersButton - Bouton non défini - action %O', action);
        return new LabelParameters('Read', {label: 'Bouton non défini'});
    }
}